const casos = [
  {
    cliente: 'Copergás',
    cidade: 'Recife — PE',
    escopo:
      'Mobiliário corporativo completo para a sede da companhia: estações de trabalho, salas de reunião e áreas administrativas.',
    imagem:
      '/media/projetos/0c732dc9-2582dc98-2019-4e5d-a1c2-11c41cf9b52c.webp',
  },
  {
    cliente: 'Sicoob',
    cidade: 'Pernambuco',
    escopo:
      'Mobiliário para agência bancária: mesas, cadeiras, balcões de atendimento e áreas de autoatendimento.',
    imagem:
      '/media/projetos/6a858509-17986c3c-1411-4fd8-b7ee-75622b38a065.webp',
  },
  {
    cliente: 'Gabinete do Prefeito de Caruaru',
    cidade: 'Caruaru — PE',
    escopo:
      'Mobiliário executivo de alto padrão para o espaço de representação institucional do município.',
    imagem:
      '/media/projetos/640f4187-img_1561.webp',
  },
  {
    cliente: 'Câmara de Ouricuri',
    cidade: 'Ouricuri — PE',
    escopo:
      'Mobiliário institucional para o plenário legislativo: cadeiras, mesas e ambientação do espaço.',
    imagem:
      '/media/projetos/b69a938c-img_1397.webp',
  },
];

export default function CasosSection() {
  return (
    <section className="bg-background-50 py-20 md:py-28">
      <div className="max-w-[1200px] mx-auto px-5 md:px-8">
        <div className="max-w-2xl mb-12 md:mb-16">
          <p className="text-[12px] md:text-[13px] font-semibold tracking-[0.28em] uppercase text-primary-500 mb-4">
            Casos reais
          </p>
          <h2 className="text-foreground-950 text-[28px] md:text-[40px] font-semibold tracking-tight leading-tight">
            Projetos que demonstram nossa capacidade de entrega.
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-5 md:gap-6">
          {casos.map((caso) => (
            <div
              key={caso.cliente}
              className="bg-white border border-background-200/70 rounded-2xl overflow-hidden"
            >
              <div className="relative aspect-[16/10] bg-background-100 overflow-hidden">
                <img
                  src={caso.imagem}
                  alt={`Projeto corporativo ${caso.cliente}`}
                  title={`Projeto ${caso.cliente} — Home Office Premium`}
                  className="w-full h-full object-cover object-top"
                  loading="lazy"
                />
              </div>
              <div className="p-6 md:p-7">
                <div className="flex items-center gap-2 mb-3">
                  <i className="ri-map-pin-2-line text-primary-500 text-base"></i>
                  <span className="text-foreground-500 text-[13px] font-medium">{caso.cidade}</span>
                </div>
                <h3 className="text-foreground-950 text-[18px] md:text-[20px] font-semibold tracking-tight mb-2">
                  {caso.cliente}
                </h3>
                <p className="text-foreground-500 text-[14px] leading-relaxed">{caso.escopo}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}